var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('TurnoverChat',{attrs:{"contact-people":_vm.contactPeople,"teams":_vm.teams,"debitors":_vm.debitors}})],1),_vm._v(" "),_c('v-row',[_c('CostStatistic')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }